import type { PropsWithChildren } from 'react';
import type { Meta, StoryFn } from '@storybook/react';
import type { CardProps } from './Card';

import { Card } from './Card';

const codeString = '<Card header={header}>{children}</Card>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Card',
  component: Card,
  argTypes: {
    highContrast: {
      control: 'boolean',
    },
    padding: {
      control: {
        type: 'select',
        options: ['small', 'regular', 'large'],
      },
    },
    alignCenter: {
      control: 'boolean',
    },
    children: {
      control: 'text',
    },
  },
  parameters: {
    inspectComponent: Card,
    codeString: codeString,
  },
} as Meta<PropsWithChildren<CardProps>>;

const Template: StoryFn<PropsWithChildren<CardProps>> = (args) => <Card {...args} />;

const defaultArgs: Partial<PropsWithChildren<CardProps>> = {
  padding: 'regular',
  highContrast: false,
  alignCenter: false,
  header: 'Example Header',
};

export const CardExample = Template.bind({});
CardExample.args = {
  ...defaultArgs,
  notification: '',
};

export const WithNotification = Template.bind({});
WithNotification.args = {
  ...defaultArgs,
  notification: 'This is an example notification',
};

export const WithChildren = Template.bind({});
WithChildren.args = {
  ...defaultArgs,
  children:
    "Chuck Norris is the reason why Waldo is hiding Remember the Soviet Union? They decided to quit after watching a DeltaForce marathon on Satellite TV, Chuck Norris CAN eat soup with a fork Morgan Freeman is the only person that could narrate Chuck Norris's life, other than himself, The quickest way to a man's heart is with Chuck Norris' fist. Chuck Norris ran in Nascar and came in 1st place. Then again, Chuck Norris wins everything.",
};
